<template>
  <div>
    <b-table
      :items="items"
      :fields="tableColumns"
      :busy="loading"
      responsive
      show-empty
      primary-key="id"
      thead-class="text-nowrap"
      class="revenue-table"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner small />
        </div>
      </template>

      <template #cell(period)="{ item }">
        <div class="d-flex align-items-center font-weight-bold id-column">
          <span class="text-nowrap">{{ item.period }}</span>
        </div>
      </template>

      <template #cell(noOfBets)="{ item }">
        <b-media vertical-align="center">
          <div class="d-flex align-items-center">
            {{ item.noOfBets }}
          </div>
        </b-media>
      </template>

      <template #cell(turnover)="{ item }">
        <b-media vertical-align="center">
          <div class="d-flex align-items-center text-nowrap">
            {{ formatCurrencyBuiltInFunc(item.turnover) }}
          </div>
        </b-media>
      </template>

      <template #cell(revenueGGR)="{ item }">
        <b-media vertical-align="center">
          <div class="d-flex align-items-center">
            {{ formatCurrencyBuiltInFunc(item.revenueGGR) }}
          </div>
        </b-media>
      </template>

      <template #cell(ggr)="{ item }">
        <b-media vertical-align="center">
          <div class="d-flex align-items-center font-weight-bolder">
            {{ item.ggr != null ? item.ggr : 0 }}%
          </div>
        </b-media>
      </template>

      <template #cell(revenueNGR)="{ item }">
        <b-media vertical-align="center">
          <div class="d-flex align-items-center">
            {{ formatCurrencyBuiltInFunc(item.revenueNGR) }}
          </div>
        </b-media>
      </template>
      <template #cell(ngr)="{ item }">
        <b-media vertical-align="center">
          <div class="d-flex align-items-center font-weight-bolder">
            {{ item.ngr != null ? item.ngr : 0 }}%
          </div>
        </b-media>
      </template>
      <template #cell(bonusMargin)="{ item }">
        <b-media vertical-align="center">
          <div class="d-flex align-items-center font-weight-bolder">
            {{ item.bonusMargin != null ? item.bonusMargin : 0 }}%
          </div>
        </b-media>
      </template>
      <template #cell(averageBet)="{ item }">
        <b-media vertical-align="center">
          <div class="d-flex align-items-center">
            {{ formatCurrencyBuiltInFunc(item.averageBet) }}
          </div>
        </b-media>
      </template>
      <template #cell(averageDepositSize)="{ item }">
        <b-media vertical-align="center">
          <div class="d-flex align-items-center">
            {{ formatCurrencyBuiltInFunc(item.averageDepositSize) }}
          </div>
        </b-media>
      </template>
    </b-table>
  </div>
</template>

<script>
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { BTable, BMedia, BSpinner } from "bootstrap-vue";
import { mapActions } from "vuex";

const PERIOD_KEYS = [
  { key: "today", label: "Today" },
  { key: "thisWeek", label: "This Week" },
  { key: "thisMonth", label: "This Month" },
  { key: "lastMonth", label: "Last Month" },
  { key: "allTime", label: "All Time" },
];

function mapPeriod(label, data) {
  return {
    period: label,
    noOfBets: data?.betCount ?? 0,
    turnover: data?.turnover ?? 0,
    revenueGGR: data?.ggr ?? 0,
    ggr: data?.ggrPercent ?? 0,
    revenueNGR: data?.ngr ?? 0,
    ngr: data?.ngrPercent ?? 0,
    bonusMargin: data?.bonusMarginPercent ?? 0,
    averageBet: data?.avgBet ?? 0,
    averageDepositSize: data?.avgDeposit ?? 0,
  };
}

export default {
  components: {
    BTable,
    BMedia,
    BSpinner,
  },
  data() {
    return {
      loading: false,
      tableColumns: [
        { key: "period", label: "Period" },
        { key: "noOfBets", label: "No. of Bets" },
        { key: "turnover", label: "Turnover" },
        { key: "revenueGGR", label: "Revenue GGR" },
        { key: "ggr", label: "GGR%" },
        { key: "revenueNGR", label: "Revenue NGR" },
        { key: "ngr", label: "NGR%" },
        { key: "bonusMargin", label: "Bonus Margin % (GMR)" },
        { key: "averageBet", label: "Average Bet" },
        { key: "averageDepositSize", label: "Average Deposit Size" },
      ],
      items: PERIOD_KEYS.map(({ label }) => mapPeriod(label, null)),
    };
  },
  watch: {
    "$route.params.id"() {
      this.fetchRevenue();
    },
  },
  mounted() {
    this.fetchRevenue();
  },
  methods: {
    ...mapActions("user/detail", ["getUserRevenue"]),
    async fetchRevenue() {
      const userId = this.$route.params.id;
      if (!userId) return;
      this.loading = true;
      try {
        const data = await this.getUserRevenue(userId);
        if (data) {
          this.items = PERIOD_KEYS.map(({ key, label }) =>
            mapPeriod(label, data[key]),
          );
        }
      } finally {
        this.loading = false;
      }
    },
  },
  setup() {
    return {
      formatCurrencyBuiltInFunc,
    };
  },
};
</script>

<style lang="scss" scoped>
.revenue-table {
  font-size: 11px;
  margin-bottom: 0;
}
</style>
